export const routes = {
    DEFAULT: '/users',
    GROUPS: '/groups',
    COMPANY_SETTINGS: '/company-settings',
} as const;

export const USER_ID_PATH_PARAM = 'userId';
export const GROUP_ID_PATH_PARAM = 'groupId';
